import { HoverBorderButton } from '@elements/Button';
import { StyledCheckbox } from '@elements/Common';
import { useState } from 'react';

export function CheckboxButton({ item, actionButtonClick }) {
  const [checked, setChecked] = useState(false);

  return (
    <div className="sk:w-full sk:flex-none sk:px-4 sk:flex! sk:items-center! sk:my-2! sk:justify-end!">
      <StyledCheckbox
        checked={checked}
        label={item.checkboxLabel}
        onChange={() => setChecked(!checked)}
      />
      {item.intermediateButton ? (
        <HoverBorderButton
          type="button"
          className={`${item.intermediateButton.layoutClass} sk:ml-5!`}
          onClick={() =>
            actionButtonClick && actionButtonClick(item.intermediateButton)
          }
        >
          {item.intermediateButton.label}
        </HoverBorderButton>
      ) : (
        <></>
      )}
      <HoverBorderButton
        type="button"
        disabled={!checked}
        className={`${item.layoutClass} sk:ml-5!`}
        onClick={() => actionButtonClick && actionButtonClick(item)}
      >
        {item.label}
      </HoverBorderButton>
    </div>
  );
}
